import { useSetRecoilState } from 'recoil';

import {
  selectedConversionYearState,
  selectedFinancialMovementYearState,
  selectedInvestmentResumeYearState,
  yearsState,
} from './atom';

export const useManagementAnalysisActions = () => {
  const setSelectedConversionYearState = useSetRecoilState(selectedConversionYearState);
  const setSelectedFinancialMovementYearState = useSetRecoilState(
    selectedFinancialMovementYearState
  );
  const setSelectedInvestmentResumeYearState = useSetRecoilState(selectedInvestmentResumeYearState);
  const setYearsState = useSetRecoilState(yearsState);

  const setSelectedConversionYear = (year: number | string) =>
    setSelectedConversionYearState(year.toString());

  const setSelectedFinancialMovementYear = (year: number | string) =>
    setSelectedFinancialMovementYearState(year.toString());

  const setSelectedInvestmentResumeYear = (year: number | string) =>
    setSelectedInvestmentResumeYearState(year.toString());

  const setYears = (years: string[]) => {
    setYearsState(years);
  };

  return {
    setSelectedConversionYear,
    setSelectedFinancialMovementYear,
    setSelectedInvestmentResumeYear,
    setYears,
  };
};
